import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[matInput][appTrimInput], textarea[matInput][appTrimInput]',
  standalone: true
})
export class TrimInputDirective {
  constructor(private readonly ngControl: NgControl) {}

  @HostListener('blur')
  onBlur(): void {
    const control = this.ngControl?.control;
    if (!control) {
      return;
    }
    const val = control.value;
    if (typeof val === 'string') {
      const trimmed = val.trim();
      if (trimmed !== val) {
        control.setValue(trimmed);
        control.updateValueAndValidity({ emitEvent: false });
      }
    }
  }
}
